import { useRef } from 'react';
import { useUpdateEffect } from 'usehooks-ts';

export function useOnChange<T>(
  value: T,
  onChange: (prev: T | undefined, value: T) => void,
) {
  const ref = useRef<T>();

  useUpdateEffect(() => {
    onChange(ref.current, value);
    ref.current = value;
  }, [value]);
}
